import request from "@/utils/request";

export function addToWishList(data) {
  return request({
    url: "/user/storeGoodsUserWish/submit",
    method: "post",
    data: data
  });
}

export function deleteFromWishList(id) {
  return request({
    url: `/user/storeGoodsUserWish/${id}/delete`,
    method: "post"
  });
}

export function getWishList(params) {
  return request({
    url: "/user/storeGoodsUserWish/page",
    method: "get",
    params: params
  });
}
